
const style:any = () => ({
	switchContainer:{
		textAlign:"center",
		paddingTop:"7px"
	}
});

export default style;
